import React from "react";
import { connect } from "react-redux";
import { Button, Form, Input, message, Modal } from 'antd'

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import ReactAbstract from "../../components/abstract/React.abstract";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';

import salaryLedgerService from "../../services/SalaryAllowance/salary-ledger-service";
import commonService from '../../services/Common/common-service'

const { Search } = Input

class SalaryWater extends ReactAbstract {

    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }

    dataMode = 1
    initReload = false
    moduleName = "salaryAllowance"
    childModuleName = "salaryWater"

    state = {
        currentModalStatus: false,
        passwordModalStatus:true,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "unload",
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "unload",
    }

    actions = {
        selectAction: salaryLedgerService.detailSalaryLedger,
    }



    filterColumn = [{
        type: "person",
        label: "请输入工号或姓名"
    },

    {
        type: "department"
    }, {
        type: "date",
        label: "结束时间",
        key: "search_end_time",
    }, {
        type: "date",
        label: "开始时间",
        key: "search_start_time",
    }
    ]

    tableColumn = [
        {
            title: '年月',
            dataIndex: 'account_monthly',
            key: 'account_monthly',
            className: 'table-global-head-small',
            fixed: 'left',
        },
        //     {
        //        title: '工号',
        //        dataIndex: 'job_number',
        //        key: 'job_number',
        //        className: 'table-global-head-small'
        //    }, {
        //        title: '中文名',
        //        dataIndex: 'employee_name',
        //        key: 'employee_name',
        //        className: 'table-global-head-small'
        //    },
        {
            title: '证件姓名',
            dataIndex: 'id_name',
            key: 'id_name',
            className: 'table-global-head',
            fixed: 'left',
        },
        //    {
        //        title: '英文名',
        //        dataIndex: 'english_name',
        //        key: 'english_name',
        //        className: 'table-global-head'
        //    }, {
        //        title: '校区',
        //        dataIndex: 'campus',
        //        key: 'campus',
        //        className: 'table-global-head'
        //    }, {
        //        title: '部门名称',
        //        dataIndex: 'department_name',
        //        key: 'department_name',
        //        className: 'table-global-head'
        //    },

        {
            title: '缴纳单位',
            dataIndex: 'pay_unit',
            key: 'pay_unit',
            className: 'table-global-head',
        },
        {
            title: '基本薪资',
            dataIndex: 'current_base_salary',
            key: 'current_base_salary',
            className: 'table-global-head-small'
        }, {
            title: '岗位工资',
            dataIndex: 'current_post_salary',
            key: 'current_post_salary',
            className: 'table-global-head-small'
        },
        //     {
        //        title: '基础保障工资',
        //        dataIndex: 'current_guarantee_salary',
        //        key: 'current_guarantee_salary',
        //        className: 'table-global-head-short'
        //    },

        {
            title: '住房补贴',
            dataIndex: 'welfare_subsidies',
            key: 'welfare_subsidies',
            className: 'table-global-head-small'
        }, {
            title: '固定津贴',
            dataIndex: 'fixed_allowance',
            key: 'fixed_allowance',
            className: 'table-global-head-small'
        },

        {
            title: '课时费',
            dataIndex: 'class_hour_fee',
            key: 'class_hour_fee',
            className: 'table-global-head-small'
        }, {
            title: '其他补贴',
            dataIndex: 'subsidy',
            key: 'subsidy',
            className: 'table-global-head-small'
        }, {
            title: '全勤奖',
            dataIndex: 'allowance',
            key: 'allowance',
            className: 'table-global-head-small'
        }, {
            title: '全部薪资',
            dataIndex: 'all_salary',
            key: 'all_salary',
            className: 'table-global-head-small'
        },
        //    {
        //        title: '业绩是否达成',
        //        dataIndex: 'is_deliver_results',
        //        key: 'is_deliver_results',
        //        className: 'table-global-head-6x',
        //        render: text => text ? "是" : "否"
        //    },
        {
            title: '迟到早退',
            dataIndex: 'come_late_deduct',
            key: 'come_late_deduct',
            className: 'table-global-head-small'
        },
        {
            title: '旷工',
            dataIndex: 'stay_away_deduct',
            key: 'stay_away_deduct',
            className: 'table-global-head-small'
        },
        {
            title: '未打卡',
            dataIndex: 'not_punched_deduct',
            key: 'not_punched_deduct',
            className: 'table-global-head-small'
        },
        {
            title: '事假',
            dataIndex: 'leave_subsidies',
            key: 'leave_subsidies',
            className: 'table-global-head-small'
        },
        // {
        //     title: "事假(小时)",
        //     dataIndex: 'personal_leave_hours',
        //     key: "personal_leave_hours",
        //     className: 'table-global-head-short'
        // },
        {
            title: '病假',
            dataIndex: 'sick_leave_subsidies',
            key: 'sick_leave_subsidies',
            className: 'table-global-head-small'
        },
        // {
        //     title: "病假(小时)",
        //     dataIndex: 'sick_leave_hours',
        //     key: "sick_leave_hours",
        //     className: 'table-global-head-short'
        // }, {
        //     title: '其他假期',
        //     dataIndex: 'other_holidays',
        //     key: 'other_holidays',
        //     className: 'table-global-head-short'
        // },
        // {
        //     title: '本期收入',
        //     dataIndex: 'current_income',
        //     key: 'current_income',
        //     className: 'table-global-head-short'
        // },
        {
            title: '应发工资',
            dataIndex: 'wage_payable',
            key: 'wage_payable',
            className: 'table-global-head-small'
        },

        {
            title: '社保个人',
            dataIndex: 'social_securitys_personal',
            key: 'social_securitys_personal',
            className: 'table-global-head-small'
        },
        {
            title: '公积金个人',
            dataIndex: 'provident_fund_rates_personal',
            key: 'provident_fund_rates_personal',
            className: 'table-global-head-short'
        },


        {
            title: '子女教育',
            dataIndex: 'children_education',
            key: 'children_education',
            className: 'table-global-head-small'
        }, {
            title: '住房贷款利息',
            dataIndex: 'home_loan_interest',
            key: 'home_loan_interest',
            className: 'table-global-head-short'
        }, {
            title: '住房租金',
            dataIndex: 'housing_rents',
            key: 'housing_rents',
            className: 'table-global-head-small'
        }, {
            title: '赡养老人',
            dataIndex: 'support_the_old',
            key: 'support_the_old',
            className: 'table-global-head-small'
        }, {
            title: '继续教育',
            dataIndex: 'adult_education',
            key: 'adult_education',
            className: 'table-global-head-small'
        }, {
            title: '专项扣除合计',
            dataIndex: 'special_total',
            key: 'special_total',
            className: 'table-global-head-short'
        }, {
            title: '代扣个税',
            dataIndex: 'withholding_tax',
            key: 'withholding_tax',
            className: 'table-global-head-small'
        }, {
            title: '税后扣款',
            dataIndex: 'post_tax_deduct',
            key: 'post_tax_deduct',
            className: 'table-global-head-small'
        },
        {
            title: '实发工资',
            dataIndex: 'real_wages',
            key: 'real_wages',
            className: 'table-global-head-small'
        }, {
            title: "代发银行1",
            dataIndex: 'payroll_bank',
            key: "payroll_bank",
            className: 'table-global-head-short'
        }, {
            title: "银行2",
            dataIndex: 'bank',
            key: "bank",
            className: 'table-global-head-small'
        }, {
            title: "银行3",
            dataIndex: 'bank2',
            key: "bank2",
            className: 'table-global-head-small'
        },
        // {
        //     title: '劳保健',
        //     dataIndex: 'laobaojian',
        //     key: 'laobaojian',
        //     className: 'table-global-head-small'
        // },
        {
            title: '现金',
            dataIndex: 'cash',
            key: 'cash',
            className: 'table-global-head-small'
        },
    ]

    togglePasswordModal = (text) => {
        commonService.checkSecondPassword({ Password : text }, (response) => {
            if (response.data.Success) {
                this.setState({
                    passwordModalStatus: !this.state.passwordModalStatus
                })
            } else {
                message.error('密码错误', 4)
            }
        })
    }

    goBack = () => {
        this.props.history.goBack()
    }

    count = ()=>{
        let { time } = this.state
        let siv = setInterval(() => {
            this.setState({ time: (time--) }, () => {
                if (time <= -1) {
                    clearInterval(siv)
                    this.setState({ loading: false, time: 59 })
                }
            })
        }, 1000)
    }

    sendSms = (e) => {
        e.preventDefault()
        commonService.sendSms({ mobile: '15921098897' }, (response) => {
            if (response.data.Success) {
                this.setState({ loading: true })
                if (this.state.time !== 0) {
                    this.count()
                }
                message.success('发送成功')
            } else {
                message.error('发送失败')
            }
        })
    }

    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        setPageFilter={this.publicChange}
                        scrollx={3000} />
                </div>
                <Modal width='300px'
                       visible={this.state.passwordModalStatus}
                       title="页面已锁定"
                       destroyOnClose={true}
                       onCancel={this.goBack}
                       footer={null}>
                    <div className="app-module-header">
                        <Form>
                            <Form.Item>
                                <Search
                                  placeholder="请输入二级密码"
                                  enterButton="确认"
                                  size="large"
                                  type="password"
                                  onSearch={text=>this.togglePasswordModal(text)}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure
    }
}

const mapDispatchToProps = {
    fetchDepartmentsList
}

SalaryWater = Form.create()(connect(mapStateToProps, mapDispatchToProps)(SalaryWater));

export default LayoutWrapper(SalaryWater);


// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryWater.js